import { useEffect, useRef, useState } from 'react';

// Crossfades between several curated background clips (see
// lib/siteImages.js -> HOME_HERO_VIDEOS) so the homepage hero feels alive and
// showcases more than one side of the business. Respects
// prefers-reduced-motion (locks to the first clip, no auto-rotation).
export const HeroVideoRotator = ({ videos, interval = 7000 }) => {
  const [active, setActive] = useState(0);
  const videoRefs = useRef([]);
  const prefersReducedMotion =
    typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  useEffect(() => {
    if (prefersReducedMotion || videos.length <= 1) return undefined;
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % videos.length);
    }, interval);
    return () => clearInterval(timer);
  }, [videos.length, interval, prefersReducedMotion]);

  useEffect(() => {
    videoRefs.current.forEach((el, i) => {
      if (!el) return;
      if (i === active) {
        el.currentTime = 0;
        el.play().catch(() => {});
      } else {
        el.pause();
      }
    });
  }, [active]);

  return (
    <div className="relative h-full w-full" data-testid="home-hero-video-rotator">
      {videos.map((v, i) => (
        <video
          key={v.key}
          ref={(el) => {
            videoRefs.current[i] = el;
          }}
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-1000 ${
            i === active ? 'opacity-100' : 'opacity-0'
          }`}
          src={v.src}
          poster={v.poster}
          muted
          loop
          playsInline
          autoPlay={i === 0}
          preload="auto"
          aria-hidden="true"
          data-testid={`home-hero-video-${v.key}`}
        />
      ))}
    </div>
  );
};
